import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import headerObject from '@/types/headerObj';
import Organization from '@/types/organizationType';

const endPoint = 'billing/getCustomerPortalUrl';
const url = apiUrl + endPoint;

export interface GetCustomerPortalUrlResponse {
  PortalUrl: string;
  Error: string;
}

const getCustomerPortalUrl = async (
  org: Organization,
  headerObj: headerObject
): Promise<GetCustomerPortalUrlResponse | undefined> => {
  const options = {
    method: 'POST',
    url: url,
    headers: {
      ...headerObj,
    },
    data: {
      OrganizationUUID: org.OrgUUID,
    },
  };

  try {
    const response = await postWithAuth(url, options.data);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    if (typeof data === 'string') {
      return JSON.parse(data);
    }

    if (data?.Error) {
      throw new Error(data?.Error);
    }

    return data;
  } catch (err) {
    console.error('Error getting customer portal URL:', err);
    return undefined;
  }
};

export default getCustomerPortalUrl;
